import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import useLang from "@/Hooks/useLang";
import Text from "@/Components/Front/Text";
import DataScience from "@/Components/Front/SVGS/Services/DataScience";
import {Link} from "@inertiajs/inertia-react";
import ChevronRight from "@/Components/Front/SVGS/ChevronRight";
import Header from "@/Components/Front/Header";
import Revisions from "@/Components/Front/SVGS/Services/Revisions";
import LineaData2 from "@/Components/Front/SVGS/LineaData2";
import ArrowBack from "@/Components/Front/SVGS/ArrowBack";
import {useMediaQuery} from "react-responsive";
import ChevronRightAlt from "@/Components/Front/SVGS/ChevronRightAlt";

export default function ServicesDataScience(props) {

    const [lang, setLang] = useLang(props.locale);


    const textProps = {
        lang: lang, language: props.language,
    };

    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isMobileAndTabletPortrait = useMediaQuery({query: '(max-width: 767px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})
    const isLg = useMediaQuery({query: '(min-width: 1024px)'})
    const isXl = useMediaQuery({query: '(min-width: 1366px)'})
    const is2Xl = useMediaQuery({query: '(min-width: 1800px)'})
    const is3Xl = useMediaQuery({query: '(min-width: 2400px)'})



    return (
        <AppLayout {...props}>
            <Header textProps={textProps} locale={lang} language={props.language} setLang={setLang} activeItem={"services-systematic-reviews"}/>

            <section id="revision" className={"services-page"}>


                {isMobile &&

                    <>
                    <div className={"back-arrow"}>
                        <Link href={"/"}>
                            <ChevronRightAlt/>
                        </Link>
                    </div>
                    <div className={"mobile-image"}>
                        <img src="images/Revisions.svg" alt=""/>

                    </div>
                    </>
                }
                <div className="in-frame-inner">
                    {isSm &&
                        <div className={"section-background"}>

                            <Revisions/>
                        </div>
                    }

                    <div className={"section-title"}>
                        <div className={"service-icon"}>
                            <LineaData2/>
                        </div>
                        <div className={"service-back-button"}>
                            <Link href={"/"}>
                                <ArrowBack/>
                            </Link>
                        </div>
                        <h1>
                            <span><Text {...textProps} str={"revisions-title-1"}/></span>
                            <span><Text {...textProps} str={"revisions-title-2"}/></span>
                        </h1>
                        <div className={"services-data-container"}>

                            <p>
                                <Text {...textProps} str={"revisions-text-1"} html={true}/>

                            </p>
                            <p>
                                <Text {...textProps} str={"revisions-text-1"} html={true}/>
                            </p>

                        </div>
                    </div>


                    <div className={"back-button"}>
                        <Link href={"/"}>

                            <button>
                                <ChevronRight/> <Text {...textProps} str={"back"}/>
                            </button>
                        </Link>
                    </div>
                </div>
            </section>
        </AppLayout>

    )
}
